import React, { useEffect } from 'react';
import {useParams} from 'react-router-dom';
import FooterTwo from '../common/footer/FooterTwo';
import HeaderOne from '../common/header/HeaderOne';
import BcrumbBannerOne from '../elements/breadcrumb/BcrumbBannerOne';
import CtaLayoutOne from '../component/cta/CtaLayoutOne';
import SectionTitle from '../elements/section-title/SectionTitle';
import ProjectPropOne from '../component/project/itemProp/ProjectPropOne';
import { slugify } from '../utils';
import ServiceData from "../data/service/ServiceMain.json";
import ProjectData from "../data/project/ProjectData.json";
import AboutTwo from '../component/about/AboutTwo';
import AboutOne from '../component/about/AboutOne';
import AboutThree from '../component/about/AboutThree';
import AboutFour from '../component/about/AboutFour';
import HeaderFive from '../common/header/HeaderFive';
import ColorSwitcher from '../elements/switcher/ColorSwitcher';
import SEO from '../common/SEO';
import Tilty from 'react-tilty';
import AOS from 'aos';
import 'aos/dist/aos.css';
import {
    FaFileInvoiceDollar,
    FaClipboardCheck
} from 'react-icons/fa';

const allServiceData = ServiceData;
const getProjectData = ProjectData;

const ServiceDetails = () => {
    useEffect(() => {

        AOS.init({
            duration: 1000,
            once: false,
            mirror: true,
            offset: 20,
            anchorPlacement: 'top-bottom'
        });

    }, []);

    const params = useParams();
    const serviceSlug = params.slug;

    const getServiceData = allServiceData.filter(data => slugify(data.title) === serviceSlug);
    const detailsService = getServiceData[0];

    return (
        <>
        <SEO title="Service Details" />
        <ColorSwitcher />
        <main className="main-wrapper">
            {/* <HeaderOne /> */}
            <HeaderFive />
            <BcrumbBannerOne 
            title={detailsService.title}
            paragraph ={detailsService.description}
            styleClass=""
            mainThumb={detailsService['image-front']}
            />
            
            <AboutFour 
                title={detailsService.title}
                module={detailsService.module}
                moduleTitle={detailsService.moduleTitle}
                moduleDescriptionFirst={detailsService.moduleDescriptionFirst}
                moduleDescriptionLast={detailsService.moduleDescriptionLast}
                image={detailsService.image}
                firstIcon={detailsService.firstIcon}
                secordIcon={detailsService.secordIcon}
            />
           
            <div className="section section-padding bg-color-light pb--70">
                <SectionTitle 
                    subtitle={detailsService.process.sectionSub}
                    title={detailsService.process.sectionTitle}
                    description={detailsService.process.para}
                    textAlignment=""
                    textColor="mb--90"
                />
                <div className="container" >
                    {detailsService.process.steps.map((data, index) => (
                        <div key={index} className={`process-work ${(index % 2  === 1) ? "content-reverse" : ""}`}>
                            <Tilty perspective={2000}>
                                <div className="thumbnail-without-color" data-aos={index % 2 === 0 ? "fade-right" : "fade-left"} data-aos-delay={index * 80} data-aos-duration="800">

                                    <img src={process.env.PUBLIC_URL + data.thumb} alt="Thumbnail" style={{ maxWidth: '350px' }}/>
                                </div>
                            </Tilty>
                        <div className="content" data-aos="fade-up" data-aos-delay={index *80} data-aos-duration="800">
                            <span className="subtitle">{data.subtitle}</span>
                            <h3 className="title">{data.title}</h3>
                            <p>{data.paragraph}</p>
                        </div>
                    </div>
                    ))}
                </div>
                <ul className="shape-group-17 list-unstyled">
                    <li className="shape shape-1"><img src={process.env.PUBLIC_URL + "/images/others/bubble-24.png"} alt="Bubble" /></li>
                    <li className="shape shape-2"><img src={process.env.PUBLIC_URL + "/images/others/bubble-23.png"} alt="Bubble" /></li>
                    <li className="shape shape-3"><img src={process.env.PUBLIC_URL + "/images/others/line-4.png"} alt="Line" /></li>
                    <li className="shape shape-4"><img src={process.env.PUBLIC_URL + "/images/others/line-5.png"} alt="Line" /></li>
                    <li className="shape shape-5"><img src={process.env.PUBLIC_URL + "/images/others/line-4.png"} alt="Line" /></li>
                    <li className="shape shape-6"><img src={process.env.PUBLIC_URL + "/images/others/line-5.png"} alt="Line" /></li>
                </ul>
            </div>
            {/* <div className="section section-padding">
                <div className="container">
                    <SectionTitle 
                        subtitle="Our Project"
                        title="Featured Designs"
                        description=""
                        textAlignment=""
                        textColor=""
                    />
                    <div className="row row-35">
                        {getProjectData.slice(0, 2).map((data) => (
                            <div className="col-md-6" key={data.id}>
                                <ProjectPropOne projectStyle="" portfolio={data}/>
                            </div>
                        ))}
                    </div>
                </div>
                <ul className="shape-group-16 list-unstyled">
                    <li className="shape shape-1"><img src={process.env.PUBLIC_URL + "/images/others/circle-2.png"} alt="circle" /></li>
                    <li className="shape shape-3"><img src={process.env.PUBLIC_URL + "/images/others/bubble-1.png"} alt="Line" /></li>
                </ul>
            </div> */}
            <CtaLayoutOne />
        <FooterTwo />
        </main>
        </>
    )
}

export default ServiceDetails;